<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          <span v-if="playerid === Note.PlayerId">Edit/</span> View
          Note
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="UpdateNote()" v-if="playerid === Note.PlayerId">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-form ref="Note" class="pa-4">
        <v-textarea auto-grow outlined label="Note" v-model="Note.Note"></v-textarea>
        <v-row v-if="playerid === Note.PlayerId">
          <v-col md="11">
            <v-combobox
              v-model="Note.tags"
              :items="campaign.Tags"
              :search-input.sync="search"
              hide-selected
              label="Add some tags"
              multiple
              small-chips
              outlined
              deletable-chips
              menu-props="closeOnContentClick"
              @change="search = ''"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      No results matching "
                      <strong>{{ search }}</strong>". Press
                      <kbd>enter</kbd> to create a new one
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
          <v-col md="1">
            <v-checkbox v-model="Note.Public" label="Public"></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <v-tooltip bottom v-if="playerid === Note.PlayerId">
      <template v-slot:activator="{ on }">
        <v-btn block class="mt-2" color="red darken-1" dark @click="deleteDialog = true" v-on="on">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>Delete Note</span>
    </v-tooltip>
    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete note?</v-card-title>
        <v-card-text>If you click Delete this note will be removed for ever.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="deleteNote()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

import { store } from "@/fb";

export default {
  data() {
    return {
      Note: { tags: [] },
      dialog: false,
      search: null,
      campaign: {},
      deleteDialog: false,
      playerid: null,
    };
  },
  methods: {
    UpdateNote() {
      let NewTags = this.campaign.Tags.concat(
        this.Note.tags.filter((item) => this.campaign.Tags.indexOf(item) < 0)
      );

      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ Tags: NewTags });
      this.Note.PlayerId = this.playerid;
      this.Note.UpdateDate = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("notes")
        .doc(this.$route.params.id)
        .update(this.Note)
        .then(this.$router.go(-1));
    },
    deleteNote() {
      db.collection("notes")
        .doc(this.$route.params.id)
        .delete()
        .then(this.$router.go(-1));
    },
  },
  firestore() {
    return {
      Note: db.collection("notes").doc(this.$route.params.id),
      campaign: db.collection("campaigns").doc(store.CurrentCampaign.id),
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((cred) => {
      this.playerid = cred.uid;
    });
  },
};
</script>
